import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline } from '@atlaskit/primitives/compiled/inline';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Stack } from '@atlaskit/primitives/compiled/stack';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

import { PersonCardWrapper } from '../person-card-wrapper';

export function PersonCardSkeleton(): React.JSX.Element {
	return (
		<PersonCardWrapper id="skeleton">
			<Stack space="space.150">
				<Inline alignInline="center">
					<Skeleton
						width="96px"
						height="96px"
						testId="skeleton"
						borderRadius={token('radius.full')}
						isShimmering
					/>
				</Inline>
				<Stack space="space.050" alignInline="center">
					<Skeleton width="140px" height="16px" testId="skeleton" isShimmering />
					<Skeleton width="100px" height="16px" testId="skeleton" isShimmering />
					<Skeleton width="100px" height="16px" testId="skeleton" isShimmering />
				</Stack>
			</Stack>
		</PersonCardWrapper>
	);
}
